<!--在留カード番号申請-->
<template>
  <div>
    <div style="margin-top:10px">
      <!-- 在留カード情報 -->
      <el-row :gutter="0">
        <div class="table-header">{{$t('MODULE.I0007_LBL_TITLE')}}</div>
      </el-row>
      <table class="i0007-table table-label">
        <!-- 氏名<br />(Full Name) -->
        <tr>
          <td class="i0007-form-label" v-html="$t('MODULE.I0007_LBL_FULLNAME')" />
          <td class="i0007-form-value">
            <el-input class="i0007-input" v-model="residentCard.residenceCardName" maxlength="100"></el-input><span style="color:red">＊</span>
          </td>
        </tr>
        <!-- 国籍<br />(Nationality) -->
        <tr>
          <td class="i0007-form-label" v-html="$t('MODULE.I0007_LBL_NATIONALITY')" />
          <td class="i0007-form-value">
            <el-select style="width:94%" v-model="nationalityCode" @change="regionCodeGet(nationalityCode)">
              <el-option v-for="(item,key) in nationality" :key="item.nationalityCode" :label="item.nationalityName" :value="item.nationalityCode">
              </el-option>
            </el-select><span style="color:red">＊</span>
          </td>
        </tr>
        <!-- 在留カード番号<br />(Residence Card No.) -->
        <tr>
          <td class="i0007-form-label" v-html="$t('MODULE.I0007_LBL_RESIDENCE_CARD_NO')" />
          <td class="i0007-form-value">
            <el-input class="i0007-input" v-model="residentCard.cardNo" maxlength="20"></el-input><span style="color:red">＊</span>
          </td>
        </tr>
        <!-- 在留カード期限<br />(Residence Card Exp Date) -->
        <tr>
          <td class="i0007-form-label" v-html="$t('MODULE.I0007_LBL_RESIDENCE_CARD_EXP')" />
          <td class="i0007-form-value">
            <el-date-picker class="i0007-picker" :editable="false" format="yyyy/MM/dd" value-format="yyyy/MM/dd" :clearable="false" type="date" v-model="residentCard.cardExpDate"></el-date-picker><span style="color:red">＊</span>
          </td>
        </tr>
        <!-- 在留カード写真<br />(Residence Card FrontsidePhoto) -->
        <tr>
          <td class="i0007-form-label" v-html="$t('MODULE.I0007_LBL_RESIDENCE_CARD_FRONTSIDEPHOTO')" />
          <td class="i0007-form-value">
            <div class="i0007_photo_border" v-if="!residentCard.residenceCardPhoto1"></div>
            <span style="color:red;float:right;margin-top:15px">＊</span>
            <el-upload class="i0007_photo_upload" ref="photo1" :file-list="photo1List" :show-file-list="true" list-type="picture-card" :limit="2" accept="image/jpeg,image/gif,image/png,image/bmp,image/jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'1')}" :auto-upload="false" multiple>
              <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
              <template slot="file" slot-scope="{file}">
                <img id="photo1Img" class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                <span class="el-upload-list__item-actions" @click="handlePhotoPreview(file,'1')">
                  <span v-if="driveLicensePhoto1LongClick" class="el-upload-list__item-delete" @click="(file, fileList) => {fileRemove(file, fileList,'1','1')}">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </template>
            </el-upload>
            <!--图片预览用dialog-->
            <el-image-viewer class="i0007_photo_icon" :on-close="photoOneDelete" v-if="photo1Dialog" :url-list="[photo1Url]" />
          </td>
        </tr>
        <!-- 在留カード裏写真<br />(Residence Card BacksidePhoto) -->
        <tr>
          <td class="i0007-form-label" v-html="$t('MODULE.I0007_LBL_RESIDENCE_CARD_BACKSIDEPHOTO')" />
          <td class="i0007-form-value">
            <div class="i0007_photo_border" v-if="!residentCard.residenceCardPhoto2"></div>
            <span style="color:red;float:right;margin-top:15px">＊</span>
            <el-upload class="i0007_photo_upload" ref="photo2" :file-list="photo2List" :show-file-list="true" list-type="picture-card" :limit="2" accept="image/jpeg,image/gif,image/png,image/bmp,image/jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'2')}" :auto-upload="false" multiple>
              <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
              <template slot="file" slot-scope="{file}">
                <img id="photo2Img" class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                <span class="el-upload-list__item-actions" @click="handlePhotoPreview(file,'2')">
                  <span v-if="driveLicensePhoto2LongClick" class="el-upload-list__item-delete" @click="(file, fileList) => {fileRemove(file, fileList,'2','1')}">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </template>
            </el-upload>
            <!--图片预览用dialog-->
            <el-image-viewer class="i0007_photo_icon" :on-close="photoTwoDelete" v-if="photo2Dialog" :url-list="[photo2Url]" />
          </td>
        </tr>
      </table>
      <el-row style="font-size:13px;padding-top:5px">
        <span>{{residentCard.statusValue}}</span>
      </el-row>
      <div>
        <el-row style="text-align:center;padding-top:10px">
          <!-- 申請按钮 -->
          <el-button class="css-btn css-button" @click="residentCardApply" :disabled="residentCard.status=='2'" type="primary" style="margin-top: 8px;font-size: 10pt;width:20%">{{$t('MODULE.I0007_LBL_APPLY')}}</el-button>
          <el-button class="css-btn css-button" @click="back" type="primary" style="margin-top: 8px;font-size: 10pt;width:20%;margin-left:10px">{{$t('MODULE.I0007_LBL_BACK')}}</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import * as amsApi from "../api/i_0007"
import css from "@/statics/css"
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import utils from '../../common/utils'
let url = require("@/../config/sysConfig")
export default {
  mixins: [css],
  components: {
    ElImageViewer
  },
  data() {
    return {
      nationality: [],//国籍
      residentCard: {
        userCd: '',//社員コード
        applyDate: '',//申請日時
        status: '',//ステータス
        statusValue: '',//申請状態
        confirmDate: '',//確認日時
        confirmUserCd: '',//確認者
        approvalDate: '',//承認日時
        approvalUserCd: '',//承認者
        transmitFlag: '',//連携フラグ
        transmitDate: '',//連携日時
        updateDate: '',//更新日時
        residenceCardName: '',//在留カード氏名
        nationalityCode: '',//国籍
        cardNo: '',//カード番号
        cardExpDate: '',//カード期限
        residenceCardPhoto1: '',//在留カード写真1
        residenceCardPhoto2: '',//在留カード写真2
      },//在留カード情報
      nationalityCode: '',
      photo1: '',
      photo2: '',
      photo1List: [],
      photo2List: [],
      photo1Dialog: false,
      photo2Dialog: false,
      photoSum: 0,
      photo1Path: '',
      photo2Path: '',
      photoUpdate1: false,
      photoUpdate2: false,
      regionCode: '',
      saveParams: [],//申请参数

      driveLicensePhoto1LongClick: false,//是否为图片长按模式（true=长按模式）。
      driveLicensePhoto2LongClick: false,//是否为图片长按模式（true=长按模式）。
    }
  },
  created() {
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd
    this.search()
  },
  methods: {
    // マスタデータ
    search() {
      var page = 'aa'
      var div = '21'
      amsApi.conditionSearch(page, div).then(res => {
        this.nationality = res.items.mstNationality
        this.query()
      })
    },

    // 在留カード情報検索
    query() {
      //实现Loading 加载方法
      this.set_loading()
      this.photoSum = 0
      amsApi.residentCardGet(this.userCd).then(res => {
        if (res.items.residentCard.length > 0) {
          this.residentCard = res.items.residentCard[0]
        }
        this.photo1List = []
        this.photo2List = []
        this.residentCard.nationalityCode = this.residentCard.nationalityDiv ? this.residentCard.nationalityDiv : this.nationality[0].nationalityCode
        this.nationalityCode = this.residentCard.nationalityCode
        this.regionCode = this.residentCard.regionCode ? this.residentCard.regionCode : this.nationality[0].regionCode
        // photo1Path与residenceCardPhoto1进行比较，判断写真是否有变更）
        this.photo1Path = this.residentCard.residenceCardPhoto1
        this.photo2Path = this.residentCard.residenceCardPhoto2
        if (this.residentCard.residenceCardPhoto1) {
          this.photoSum += 1
          this.photoQuery(this.residentCard.residenceCardPhoto1, 'photo1List')
        }
        if (this.residentCard.residenceCardPhoto2) {
          this.photoSum += 1
          this.photoQuery(this.residentCard.residenceCardPhoto2, 'photo2List')
        }
        if (!this.residentCard.residenceCardPhoto1 && !this.residentCard.residenceCardPhoto2) {
          this.close_loading()
        }
      }).catch((err) => {
        this.close_loading()
      });
    },

    // 写真检索
    photoQuery(filePath, fileListName) {
      this[fileListName] = []
      this.photoSum -= 1
      var resizeCd = '0'
      let fileUrl = {};
      fileUrl.name = filePath.split('/')[filePath.split('/').length - 1]
      amsApi.i_0007_getImage(filePath, resizeCd).then(res_file => {
        let blob = new Blob([res_file], { type: 'application/octet-stream;charset=UTF-8' })
        let url = window.URL.createObjectURL(blob);
        fileUrl.url = url;
        if (fileUrl.name.indexOf("%26") !== -1) {
          fileUrl.name = fileUrl.name.replace('%26', '&')
        }
        if (fileUrl.name.indexOf("%2F") !== -1) {
          fileUrl.name = fileUrl.name.replace('%2F', '/')
        }
        if (fileUrl.name.indexOf("%3F") !== -1) {
          fileUrl.name = fileUrl.name.replace('%3F', '?')
        }
        if (fileUrl.name.indexOf("%23") !== -1) {
          fileUrl.name = fileUrl.name.replace('%23', '#')
        }
        if (fileUrl.name.indexOf("%25") !== -1) {
          fileUrl.name = fileUrl.name.replace('%25', '%')
        }
        this[fileListName].push(fileUrl);
        if (this.photoSum == 0) {
          this.close_loading()
        }
      }).catch((err) => {
        this.close_loading()
      });
    },

    // 在留カード情報申请
    residentCardApply() {
      if (!this.saveParamsCheck()) {
        return
      }
      //データを保存します。よろしいでしょうか？
      this.$confirm(this.$t('COMMON.MSG_CONFIRM_CHANGE'), this.$t('COMMON.CONFIRM'), {
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//いいえ
        customClass: 'i0007textCenter'
      }).then(() => {
        // はい：処理を続ける					
        this.confirmApply()
      }).catch(() => {
        //いいえ：処理せず
      });
    },

    //  はい：処理を続ける
    confirmApply() {
      this.photoSum = 0
      this.saveParamsGet()
      //实现Loading 加载方法
      this.set_loading()
      // 写真变更の場合 
      if (this.photoUpdate1) {
        this.photoSave(this.photo1, this.residentCard.residenceCardPhoto1, '1')
      }
      if (this.photoUpdate2) {
        this.photoSave(this.photo2, this.residentCard.residenceCardPhoto2, '2')
      }
      if (!this.photoUpdate1 && !this.photoUpdate2) {
        this.paramsSave()
      }
    },

    // 在留カード情報保存
    paramsSave() {
      amsApi.residentCardSave(this.saveParams).then(res => {
        if (res.code === 202) {
          this.changeFgl = false
          this.$message.success({ message: this.$t('COMMON.MSG_INSERTED'), showClose: true }) // 保存しました。
          this.query()
        } else if (res.code === 308) {
          this.$confirm(this.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            customClass: 'i0007textCenter'
          }).then(() => {
            this.query()
          }).catch(() => {
            this.close_loading()
          })
        } else if (res.code === 311) {
          this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//処理が失敗しました。
          this.close_loading()
        }
      })
    },

    // 写真保存
    photoSave(photoFiles, photoPath, type) {
      var photoFormData = new FormData()
      photoFormData.append('files', photoFiles, photoPath)
      amsApi.i_0007_saveImage(photoFormData).then(res => {
        this['photoUpdate' + type] = false
        this.photoSum += 1
        // 变更的写真都成功上传后，保存申请参数
        if (!this.photoUpdate1 && !this.photoUpdate2) {
          if (res.code == 205) {
            this.paramsSave()
          } else if (res.code == 311) {
            //图片上传失败
            this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true }) // 更新失敗
            this.close_loading()
          }
        }
      })
    },

    // 申请参数
    saveParamsGet() {
      this.saveParams = []
      var params = {}
      //ステータスは3：承認済の場合、新規と見なす
      params.userId = this.userCd          // 社員コード
      params.residenceCardName = this.residentCard.residenceCardName            // 氏名
      params.nationalityDiv = this.nationalityCode          // 国籍
      params.cardNo = this.residentCard.cardNo       // カード番号
      params.cardExpDate = this.residentCard.cardExpDate           // カード期限
      params.regionCode = this.regionCode
      // 写真变更の場合\
      params.residenceCardPhoto1 = this.photoUpdate1 ? this.residentCard.residenceCardPhoto1 : null// 在留カード写真
      params.residenceCardPhoto2 = this.photoUpdate2 ? this.residentCard.residenceCardPhoto2 : null// 在留カード裏写真

      if (this.residentCard.status == '3' || this.residentCard.status == '') {
        params.id = null
        params.updateDate = null
      } else {
        params.id = this.residentCard.id
        params.updateDate = this.residentCard.updateDate
      }
      this.saveParams.push(params)
    },

    // 保存参数check
    saveParamsCheck() {
      //  氏名
      if (!this.residentCard.residenceCardName) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0007_LBL_FULLNAME').split('<br />')[0]), showClose: true })
        return false
      }
      //  在留カード番号
      if (!this.residentCard.cardNo) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0007_LBL_RESIDENCE_CARD_NO').split('<br />')[0]), showClose: true })
        return false
      }
      //  在留カード期限
      if (!this.residentCard.cardExpDate) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0007_LBL_RESIDENCE_CARD_EXP').split('<br />')[0]), showClose: true })
        return false
      }
      //  在留カード写真
      if (!this.residentCard.residenceCardPhoto1) {
        this.$message.error({ message: this.$t('MODULE.I0007_MSG_UPLOAD_PHOTO_FRONT'), showClose: true })
        return false
      }
      //  在留カード裏写真
      if (!this.residentCard.residenceCardPhoto2) {
        this.$message.error({ message: this.$t('MODULE.I0007_MSG_UPLOAD_PHOTO_BACK'), showClose: true })
        return false
      }
      return true
    },

    // 图片上传选择
    handleChange(file, fileList, type) {
      var file_type = file.raw.type
      // 上传图片的格式判定，失败的场合不上传
      if (!(file_type === 'image/jpeg' || file_type === 'image/gif' || file_type === 'image/png' || file_type === 'image/bmp' || file_type === 'image/jpg')) {
        this.$message.error({ message: this.$t('COMMON.MSG_PICTURE_FORMAT'), showClose: true });
        // 回复原来的样子
        if (fileList.length == 1) {
          fileList = fileList.splice(0, 1);
        }
        if (fileList.length > 1) {
          fileList = fileList.splice(1, 1);
        }
        return
      }

      this['photo' + type + 'LongClick'] = false
      if (file.status === "ready") {
        // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
        if (fileList.length === 2) {
          fileList.shift();
        }
      }
      this['photoUpdate' + type] = true
      var that = this
      // 压缩
      let blob = new Blob([file.raw], { type: file.raw.type })
      this.compressImg(blob, file.name).then(async res => {
        // 照片文件
        that['photo' + type] = res
        //写真アップロード時のＵＲＬ: image/userInfo/社員コード/residentCard/1_yyyyMMddHHmmssSSS.拡張子																					
        that.residentCard['residenceCardPhoto' + type] = url.imgUrl_UserInfo + that.userCd + '/residentCard/' + type + '_' + utils.timeNumberGet() + '.' + file.name.split('.').pop()
      })
    },

    // base转file
    base64ToFile(file, fileName) {
      var arr = file.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName, { type: mime });
    },


    // 压缩图片
    compressImg(file, fileName) {
      var that = this
      var files;
      var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
      var read = new FileReader();
      read.readAsDataURL(file);
      return new Promise(function (resolve, reject) {
        read.onload = function (e) {
          var img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            //默认按比例压缩
            var w = this.width,
              h = this.height;
            //生成canvas
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var base64;
            // 创建属性节点
            canvas.setAttribute("width", w);
            canvas.setAttribute("height", h);
            ctx.drawImage(this, 0, 0, w, h);
            if (fileSize <= 1) {
              //如果图片小于一兆 那么不执行压缩操作
              base64 = canvas.toDataURL(file['type'], 0.94);
            } else if (fileSize > 1 && fileSize <= 5) {
              //如果图片大于1M并且小于5M 
              base64 = canvas.toDataURL(file['type'], 0.35);
            } else if (fileSize > 5 && fileSize <= 8) {
              base64 = canvas.toDataURL(file['type'], 0.2);
            } else if (fileSize > 8 && fileSize <= 12) {
              base64 = canvas.toDataURL(file['type'], 0.1);
            } else {
              base64 = canvas.toDataURL(file['type'], 0.05);
            }
            // 回调函数返回file的值（将base64编码转成file）
            files = that.base64ToFile(base64, fileName); //如果后台接收类型为base64的话这一步可以省略
            resolve(files)
          };
        };
      })
    },

    //单张图片点击
    handlePhotoPreview(file, type) {
      this['photo' + type + 'Url'] = file.url;
      this['photo' + type + 'Dialog'] = true;
    },
    // 照片1删除
    photoOneDelete() {
      // 写真を削除しても、よろしいでしょうか？
      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), {
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(() => {
        //组件表示图片清空
        this.photo1List = []
        this.residentCard.residenceCardPhoto1 = ""
        //上传用list清空
        this.photo1Url = '';
        this.photo1Dialog = false;
        this.photo1Img = {}
      }).catch(() => {
      })
    },
    // 照片2删除
    photoTwoDelete() {
      // 写真を削除しても、よろしいでしょうか？
      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), {
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(() => {
        //组件表示图片清空
        this.photo2List = [];
        this.residentCard.residenceCardPhoto2 = ""
        //上传用list清空
        this.photo2Url = '';
        this.photo2Dialog = false;
        this.photo2Img = {}
      }).catch(() => {
      })
    },

    // 地域コード取得
    regionCodeGet(val) {
      let nationality = {}
      nationality = this.nationality.find((item) => {
        return item.nationalityCode === val
      })
      // 地域コード
      this.regionCode = nationality.regionCode
    },

    // 戻る
    back() {
      this.$router.go(-1)
    }
  },
  mounted() {
    //点击删除按钮之外的地方退出长按模式
    let that = this;
    document.addEventListener('click', function (e) {
      if (e.target.className != 'el-icon-delete') {
        that.driveLicensePhoto1LongClick = false//是否为图片长按模式（true=长按模式）。
        that.driveLicensePhoto2LongClick = false//是否为图片长按模式（true=长按模式）。
      }
      if (e.target.className != 'el-upload-list__item-actions'
        && e.target.className != 'el-icon-refresh-left'
        && e.target.className != 'el-icon-refresh-right'
        && e.target.className != 'el-icon-c-scale-to-original'
        && e.target.className != 'el-icon-zoom-in'
        && e.target.className != 'el-icon-zoom-out'
        && e.target.className != 'el-image-viewer__actions__inner'
        && e.target.className != 'el-icon-full-screen'
        && e.target.className != 'el-icon-circle-close'
        && e.target.className != 'el-button el-button--default el-button--small'
      ) {
        //关闭照片查看器
        that.photo1Dialog = false
        that.photo2Dialog = false
      }
    })
  }
}
</script>
<style >
/* 表格边框、字体样式 */
.i0007-table {
  border-collapse: collapse;
  width: 100%;
}
/* 表格边框颜色 */
.i0007-table tr td {
  border: 1px solid #ccc;
}

.i0007-form-value,
.i0007-form-value tr td {
  padding-right: 0 !important;
}
/* 表格内边距 */
.i0007-table td {
  padding: 5px 8px;
}
/* 表格第一列背景色、宽度、文字居右 */
.i0007-form-label {
  text-align: right;
  width: 110px;
  background: #d2eef8;
}
/* input样式 */
.i0007-input {
  width: 94%;
}
.i0007-input .el-input__inner {
  padding: 0 12px 0 12px;
}

/* 在留カード期限 */
.i0007-form-value .el-date-editor.el-input {
  width: 94%;
}

/* 按钮间距 */
.i0007-button.el-button + .el-button {
  margin-left: 0%;
}
.css-button_i0007 {
  background-image: linear-gradient(#3cc6fa, #1197ca);
  color: #ffffff;
  width: 100%;
  font-size: 10pt;
}
/* 左边空图片蓝色边框 */
.i0007_photo_border {
  float: left;
  width: 40%;
  height: 40px;
  margin-left: 0px;
  margin-top: 5px;
  position: relative;
  border: 1px solid #409eff;
  border-radius: 5px;
}

.i0007_photo_upload .el-upload--picture-card {
  width: 40%;
  height: 43px;
  margin-top: 5px;
  margin-left: 6px;
  background-color: #d2eef8;
  border: 1px solid #409eff;
  line-height: 0;
}

/* 图片样式 */
.i0007_photo_upload .el-upload-list--picture-card .el-upload-list__item {
  width: 40%;
  height: 43px;
  margin: 5px 0 0 0;
  border: none;
}

/* 图片上传按钮样式 */
.i0007_photo_upload .el-upload--picture-card i {
  margin-top: 5px;
  color: #409eff;
}
/* 去除上传图片动画 */
.i0007_photo_upload .el-upload-list__item {
  transition: none !important;
}

.i0007_photo_icon .el-icon-circle-close:before {
  color: #fd270a;
}

.i0007-css-btn {
  color: #fff;
  margin-top: 15px;
  width: 100px;
  height: 40px;
  padding-top: 10px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
}
/*按钮经过样式*/
.i0007-css-btn:hover {
  color: #fff;
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
}

/*按钮激活和焦点样式*/
.i0007-css-btn:active,
.i0007-css-btn:focus {
  color: #fff;
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
}
.i0007textCenter .el-message-box__btns {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0007.vue